export interface IFormat {
  id: number;
  format: string;
  description: string;
}

export interface ICatalog {
  timezoneFormats: IFormat[];
  dateFormats: IFormat[];
  timeFormats: IFormat[];
  unitOfMeasureFormats: IFormat[];
}

export enum CatalogDefault {
  TIMEZONE = '(GMT-12:00) International Date Line West',
  DATE = 'MM-dd-yyyy',
  TIME = 'hh:mm a',
  UNIT_OF_MEASURE = 'Imperial',
}

export const catalogMockData = {
  dateFormat: CatalogDefault.DATE,
  timeFormat: CatalogDefault.TIME,
  timeZone: CatalogDefault.TIMEZONE,
  unitOfMeasure: CatalogDefault.UNIT_OF_MEASURE,
};
